/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { SocialShare } from "@quintype/components";
import { object, array, string, func } from "prop-types";

import MetypeCommentWrapper from "../../metype-comments";
import Demarcation from "../../atoms/demarcation";
import StoryMetaInfo from "../../molecules/story-meta-info";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import StoryCard from "../story-card";
import StoryTag from "../story-tag";
import SideBar from "../side-bar";
import RelatedStories from "../related-stories";
import Adsense from "../../adsense";
import { storyShareClickHandler } from "../../utils";

import "./photo.m.css";

class PhotoStoryTemplate extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      renderMetype: false,
      showReadmore: {},
      wrapperClass: "",
      addReadmore: false,
      width: null
    };
  }

  getPhotoCardCount = cards => {
    let count = 0;
    const newCards = [...cards];
    const modifiedCards = newCards.map(card => {
      const newCard = Object.assign({}, card);

      newCard["story-elements"] = newCard["story-elements"].map(element => {
        if (element.type === "image") {
          count++;
          element.imageIndex = count;
          return element;
        } else {
          return element;
        }
      });
      return newCard;
    });
    return { modifiedCards, count };
  };

  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();

    this.setState({
      renderMetype: true
    });
  }

  render() {
    const { story, trendingStories, collectionName, recentStories, config } = this.props;
    const { modifiedCards: cards, count } = this.getPhotoCardCount(story.cards);
    const publisherUrl = config["sketches-host"] || "https://www.freepressjournal.in";

    return (
      <React.Fragment>
        <div styleName="wrapper">
          <div>
            <StoryMetaInfo story={story} />
            {this.state.width <= 992 && (
              <div styleName="dfp-ad-300x100">
                <Adsense adSlotId="3689255812" width="300" height="250" />
              </div>
            )}
            {this.state.width >= 992 && (
              <div styleName="dfp-ad-728x90">
                <Adsense adSlotId="5135370519" width="720" height="90" />
              </div>
            )}
            <div styleName="story-content">
              <div>
                <SocialShare
                  template={StickySocialShareTemplate}
                  title={story.headline}
                  url={story.slug}
                  color="#000"
                  sticky
                  onClick={storyShareClickHandler(story["story-content-id"], `${publisherUrl}/${story.slug}`)}
                />
              </div>
              <div styleName="photo-story-content">
                <div ref={divElement => (this.divElement = divElement)}>
                  <div styleName="content-wrapper">
                    {cards &&
                      cards.length &&
                      cards.map((card, index) => {
                        return (
                          <React.Fragment key={card.id}>
                            {index !== 0 &&
                              index % 3 === 0 && (
                                <div styleName="dfp-ad2-728x90">
                                  <Adsense adSlotId="5135370519" width="720" height="90" />
                                </div>
                              )}
                            {<StoryCard key={card.id} card={card} story={story} cardCount={count} template={"photo"} />}
                          </React.Fragment>
                        );
                      })}
                    <div styleName="dfp-ad2-728x90">
                      <Adsense adSlotId="5135370519" width="720" height="90" />
                    </div>
                    <StoryTag tags={story.tags} />
                    {this.state.renderMetype && <MetypeCommentWrapper story={story} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <SideBar stories={recentStories} collectionName={collectionName} id={story.id} />
          </div>
        </div>
        <div styleName="related-stories">
          <RelatedStories relatedStories={trendingStories} collectionName="trending" />
          <div id={`${story.slug}`} />
        </div>
      </React.Fragment>
    );
  }
}

function PhotoStory(props) {
  return (
    <div className="story-grid">
      <PhotoStoryTemplate
        story={props.story}
        trendingStories={props.trendingStories}
        collectionName={props.collectionName}
        recentStories={props.recentStories}
        config={props.config}
      />
      <Demarcation />
    </div>
  );
}

PhotoStoryTemplate.propTypes = {
  story: object,
  trendingStories: array,
  collectionName: string,
  recentStories: array,
  config: func
};

PhotoStory.propTypes = {
  story: object,
  trendingStories: array,
  collectionName: string,
  recentStories: array,
  config: func
};

export default PhotoStory;
